export const Role = {
    Admin: 'Admin',
    AdminWeb: 'AdminWeb',
    User: 'User'
}